
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators'
import { NavigationExtras, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { CommonDataService } from './common-data.service';
@Injectable()
export class httpInterceptor implements HttpInterceptor {

  constructor(private router: Router, public authService: AuthService, private _commonDataService: CommonDataService) { }
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    //request.url.contains
    if (this.authService.getJwtToken()) {
      request = this.addToken(request, this.authService.getJwtToken(), next);
    }

    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return this.handle401Error(request, next)
      }
      else {
        if (error.error.errorCode === 999) {
          const navigationdata: NavigationExtras = {
            state:
            {
              errorId: error.error.exceptionId,
              statuscode: error.error.errorcode,
              url: error.error.supportUrl
            }
          }
          return this.router.navigate(['\Error'], navigationdata);
        }

        // return throwError(error);
      }
    }));
  }

  private addToken(request: HttpRequest<any>, token: string, next: HttpHandler) {
    //if (localStorage.getItem('TOKEN_Expiry') != null) {
    //  let expTime = new Date(localStorage.getItem('TOKEN_Expiry'));
    //  let currentTime = new Date();
    //  if (expTime < currentTime) {
    //    localStorage.removeItem('TOKEN_Expiry');
    //    this.isRefreshing = false;
    //    this.tokenRefresh(request, next);
    //    let obj={
    //      type : 'success',
    //      displayTime : 3000,
    //      position : 'bottom',
    //      message : "Token refreshed after expiry."
    //    }
    //    this._commonDataService.notificationObject.next(obj);
    //  }
    //}
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }



  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {

    //if (localStorage.getItem('REFRESH_TOKEN') != null) {
    //  if (!this.isRefreshing) {
    //    this.isRefreshing = true;
    //    this.refreshTokenSubject.next(null);

    //    return this.authService.refreshToken().pipe(
    //      switchMap((token: any) => {

    //        this.isRefreshing = false;
    //        this.refreshTokenSubject.next(token.token);
    //        return next.handle(this.addToken(request, token.token, next));
    //      }));

    //  } else {
    //    return this.refreshTokenSubject.pipe(
    //      filter(token => token != null),
    //      take(1),
    //      switchMap(jwt => {
    //        return next.handle(this.addToken(request, jwt.token, next));
    //      }));
    //  }
    //}
    //else
    {
      let obj = {
        type: 'error',
        displayTime: 3000,
        position: 'bottom',
        message: "You are not authorized , please login"
      }
      this._commonDataService.notificationObject.next(obj);
      this.router.navigate(["Login"]);
      return throwError("Attempt to access without login");
    }
  }
  private tokenRefresh(request: HttpRequest<any>, next: HttpHandler) {
    if (localStorage.getItem('REFRESH_TOKEN') != null) {
      if (!this.isRefreshing) {
        this.isRefreshing = true;
        this.refreshTokenSubject.next(null);

        return this.authService.refreshToken().subscribe(
          (token: any) => {
            this.isRefreshing = false;
            this.refreshTokenSubject.next(token.token);
            return next.handle(this.addToken(request, token.token, next));
          });

      } else {
        return this.refreshTokenSubject.pipe(
          filter(token => token != null),
          take(1),
          switchMap(token => {
            return next.handle(this.addToken(request, token.token, next));
          }));
      }
    }
  }
}
